export default function ({commit, dispatch, getters}) {
    let loading = {
        paymentOperation: true,
        cash: true,
        paymentAccount: true,
        paymentType: true,
        paymentCatalogsData: true,
    };
    let dNumber;
    commit('set', {Id: -1});
    commit('loading', true);
    dispatch('subsidies/item/change', {field: 'tab', value: 'payment'}, {root: true});

    dispatch('dictionaries/paymentOperation/select/get', {
        cb: () => {
            loading.paymentOperation = false;
            add();
        }
    }, {root: true});
    dispatch('dictionaries/cash/select/get', {
        cb: () => {
            loading.cash = false;
            add();
        }
    }, {root: true});
    dispatch('dictionaries/paymentAccount/select/get', {
        cb: () => {
            loading.paymentAccount = false;
            add();
        }
    }, {root: true});
    dispatch('dictionaries/paymentType/select/get', {
        cb: () => {
            loading.paymentType = false;
            add();
        }
    }, {root: true});

    axios({
        method: 'get',
        url: '/tourclient/payment/paymentCatalogsData?_' + new Date().getTime(),
    }).then(({data}) => {
        dNumber = data.IncomePaymentNumber;
        loading.paymentCatalogsData = false;
        add();
    }).catch((error) => {
        dispatch('error', error, {root: true});
    });

    function add() {
        for (let k in loading) {
            if (loading[k]) return;
        }
        switch (getters.form.ContragentType) {
            case 1:
                dispatch('change', {field: 'PaymentOperationID', value: 1});
                break;
            case 2:
                dispatch('change', {field: 'PaymentOperationID', value: 3});
                break;
        }
        dispatch('change', {field: 'CashId', value: getters.cash[0].value});
        dispatch('change', {field: 'PaymentAccountId', value: getters.paymentAccount[0].value});
        commit('set', {
            Sum: getters.form.Sum,
            PaymentDate: new Date().toStringRu(),
            DocumentNumber: dNumber,
            Comment: '',
            AgreementCodes: [],
        });
        commit('loading');
    }
}
